








import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Money from '@/components/shared/format/Money.vue'

const components = { Money }


@Component({ components })
export default class Nominators extends Vue {
  @Prop() public nominators!: any[];

}
